import React, { Fragment, MouseEvent } from 'react';
import { useTracking } from '../../tools/analytics';
import { Picto, PictoProps, pictos } from '../Picto';
import { Loader } from '../Picto/Loader';

export interface ButtonV2Props
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  text?: string;
  leftIcon?: keyof typeof pictos;
  rightIcon?: keyof typeof pictos;
  leftIconProps?: PictoProps;
  rightIconProps?: PictoProps;
  align?: 'left' | 'center' | 'right';
  variant?: 'solid' | 'outline' | 'clear';
  isLoading?: boolean;
  link?: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >['href'];
  linkTarget?: React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  >['target'];
  children?: React.ReactNode;
  color?: string;
  trackingKey?: string;
}

const ButtonV2: React.FC<ButtonV2Props> = ({
  text,
  leftIcon,
  rightIcon,
  align = 'center',
  variant = 'solid',
  isLoading,
  link,
  linkTarget,
  className,
  children,
  onClick,
  trackingKey,
  ...rest
}) => {
  const { trackEvent } = useTracking();

  const TextComp = link ? 'a' : 'button';
  const compProps = link
    ? ({
        href: link,
        target: linkTarget ? linkTarget : '_self',
        style: {
          color: rest?.color && variant !== 'solid' ? rest.color : undefined,
          backgroundColor: rest?.color && variant === 'solid' ? rest.color : undefined,
        },
      } as React.AnchorHTMLAttributes<HTMLAnchorElement>)
    : ({} as React.ButtonHTMLAttributes<HTMLButtonElement>);

  const onClickHandler: any = (e: MouseEvent<HTMLAnchorElement & HTMLButtonElement>) => {
    if (trackingKey) trackEvent(trackingKey);
    onClick?.(e);
  };

  return (
    // @ts-ignore
    <TextComp
      className={`ButtonV2 ButtonV2--${variant} ButtonV2--${align} ${link ? 'ButtonV2--link' : ''} ${className ?? ''}`}
      style={{
        ...compProps.style,
        ...(rest.style ?? {}),
      }}
      onClick={onClickHandler}
      {...compProps}
    >
      {isLoading ? (
        <div className="ButtonV2__loader">
          <Loader />
        </div>
      ) : (
        <Fragment>
          {leftIcon ? <Picto iconKey={leftIcon} /> : null}
          {text ? <span className="ButtonV2__text">{text}</span> : null}
          {children ? children : null}
          {rightIcon ? <Picto iconKey={rightIcon} /> : null}
        </Fragment>
      )}
    </TextComp>
  );
};

export default ButtonV2;
